module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.5-update.f0902fc4.png";